import { BONDS_STORE_NAME } from '@/creditflowresearch/application/Bonds/constants';
import SharedFooter from '@framework/ui/Organisms/Filters/FiltersPanel/Footer';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';

const SharedFooterContainer = (props) => {
  const { getFilters } = useFiltersContext();
  const { filtersPayload, appliedFilters, initialFilters } = useBondsFiltersContext();
  const filters = getFilters(BONDS_STORE_NAME);

  return (
    <SharedFooter
      { ...props }
      filters={ filters }
      filtersPayload={ filtersPayload }
      appliedFilters={ appliedFilters }
      initialFilters={ initialFilters }
    />
  );
};

export default SharedFooterContainer;
